import elementResizeDetectorMaker from "element-resize-detector"; // 盒子大小监听插件
import {
  deepCopy
} from "@/utils/deepCopy.js";
import {
  validatePhone,
  validateEmail
} from "@/utils/validate";
import {
  getEnumMetaData,
  getEnumMetaValue
} from "@/utils/getEnumMeta";
import {
  getCompanySettings
} from "@/http/api/system";
import {
  getCompanieDetail,
  updateCompanie,
  getPartners,
  getMaterials,
  addPartners,
  removePartners,
  updatePartners,
  updateStatus
} from "@/http/api/company";
export default {
  data() {
    var validateFormPhone = (rule, value, callback) => {
      if (value === '') {
        callback();
      } else if (!validatePhone(value)) {
        callback(new Error('手机号格式不正确'));
      } else {
        callback();
      }
    };
    var validateFormEmail = (rule, value, callback) => {
      if (value === '') {
        callback();
      } else if (!validateEmail(value)) {
        callback(new Error('邮箱格式不正确'));
      } else {
        callback();
      }
    };
    return {
      loading:true,
      headerText: "分销商管理",
      isScrollShow: false, // 头部滚动内容显示
      isHeaderInit: false,
      isHeaderShadow: false, // 头部阴影显示
      isHeaderVisible: false, // 滚动头部显示
      isTagsShow: true, // 标签/输入框显示
      isRemarkShow: false, // 标签备注窗口显示
      partners: [], //股东
      editPartnerData: {}, //存储编辑股东的信息
      company: {
        status: '', //状态
        name: '', //名称
        alias: '', //简称
        email: '', //邮箱
        phoneNumber: '', //手机号
        registerAddress: '', //工商注册地址
        currentAddress: '', //实际经营地址
        businessLicense: '', //营业执照号码
        totalMembers: 0, //目标店数
        recruitWay: '', //加盟渠道来源
        nature: '', //公司性质
        hasQualifications: true, //是否有房地产经纪资质
        owner: '', //公司法人
        ownerPhoneNumber: '', //公司法人联系电话
        ownerCardType: '', //公司法人证件类型
        ownerCardNumber: '', //公司法人证件号码
        more: '', //备注
        type: '', //分销商类型
        tags: [], //标签
      },
      companyRules: {
        // businessLicense: [{
        //   required: true,
        //   message: '请输入营业执照号码',
        //   trigger: 'blur'
        // }],
        name: [{
          required: true,
          message: '请输入分销商名称',
          trigger: 'blur'
        }],
        // owner: [{
        //   required: true,
        //   message: '请输入公司法人',
        //   trigger: 'blur'
        // }],
        // type: [{
        //   required: true,
        //   message: '请选择分销商类型',
        //   trigger: 'change'
        // }],
        // // status: [{
        // //   required: true,
        // //   message: '请选择分销商状态',
        // //   trigger: 'change'
        // // }],
        // nature: [{
        //   required: true,
        //   message: '请选择公司性质',
        //   trigger: 'change'
        // }],
        // hasQualifications: [{
        //   required: true,
        //   message: '请选择是否有房地产经纪资质',
        //   trigger: 'change'
        // }],
        phoneNumber: [{
          validator: validateFormPhone,
          trigger: 'blur'
        }],
        email: [{
          validator: validateFormEmail,
          trigger: 'blur'
        }],
        // ownerPhoneNumber: [{
        //   required: true,
        //   message: '请输入公司法人联系电话',
        //   trigger: 'blur'
        // }, {
        //   validator: validateFormPhone,
        //   trigger: 'blur'
        // }],
        // ownerCardType: [{
        //   required: true,
        //   message: '请选择公司法人证件类型',
        //   trigger: 'change'
        // }],
        // ownerCardNumber: [{
        //   required: true,
        //   message: '请输入公司法人证件号码',
        //   trigger: 'blur'
        // }]
      },
      //标签
      tagNum: 3,
      headTag: '',
      isTagChange: false,
      // 备注表单
      remarkForm: {
        more: "",
      },
      isRemarkChange: false,
      //头像
      isLoading: false,
      // 选项
      companyNatureOptions: [], //公司性质
      recruitWayOptions: [], //渠道来源
      companyTypeOptions: [], //分销商类型
      companyStatusOptions: [], //分销商状态
      // 证件类型
      ownerCardTypeOptions: [{
        option: '大陆身份证',
      }, {
        option: '军官证',
      }, {
        option: '港台身份证',
      }, {
        option: '护照',
      }, {
        option: '驾驶证',
      }, {
        option: '其他',
      }],
      editPartnersIndex: null,
      isAddPartnersShow: false,
      //股东表单
      partnersForm: {
        name: '',
        cardType: '',
        cardNumber: '',
        phoneNumber: '',
        more: ''
      },
      partnersRules: {
        name: [{
          required: true,
          message: '请输入股东姓名',
          trigger: 'blur'
        }],
        cardType: [{
          required: true,
          message: '请选择股东证件类型',
          trigger: 'change'
        }],
        cardNumber: [{
          required: true,
          message: '请输入股东证件号',
          trigger: 'blur'
        }],
        phoneNumber: [{
          required: true,
          message: '请输入股东电话',
          trigger: 'blur'
        }, {
          validator: validateFormPhone,
          trigger: 'blur'
        }]
      },
      isEditBasic: false,
      //隐藏数字信息
      hideInfo: {
        headerPhone: true,
        phoneNumber: true,
        ownerPhoneNumber: true
      },
      permissions: this.$store.getters.permissions,
    }
  },
  mounted() {
    this.getPartners(); //股东信息
    this.getMaterials(); //获取图片
    this.getCompanieDetail(); //获取详情
    this.getCompanySettings(); //获取公司设置
    //分销商类型
    this.companyTypeOptions = getEnumMetaData(this.$store.getters.enumMetadata, 'CompanyType');
    //分销商状态
    this.companyStatusOptions = getEnumMetaData(this.$store.getters.enumMetadata, 'CompanyStatus');

    //监听滚动
    let el = document.querySelector(".edit-employe");
    el.addEventListener("scroll", this.scrollScreen);
    if (!this.isHeaderInit) {
      this.erd = elementResizeDetectorMaker();
      this.erd.listenTo(el, this.headerInit);
      this.headerInit();
    }
  },
  methods: {
    //签约、解约
    preUpdateStatusHandle(type) { //type:Waiting  Joined
      if (type == 'Waiting' || type == 'Dropped') { //执行签约
        this.$confirm('即将进行签约操作, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.updateStatus('Joined');
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消签约'
          });
        });
      } else if (type == 'Joined') { //执行解约
        this.$confirm('即将进行解约操作, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.updateStatus('Dropped');
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消解约'
          });
        });
        // this.updateStatus('Waiting');
      }
    },
    updateStatus(status) {
      updateStatus(this.$route.params.id, {
        status
      }).then(res => {
        res.result.typeVal = res.result.type; //存储展示用
        res.result.statusVal = res.result.status; //存储展示用
        res.result.type = getEnumMetaValue(this.$store.getters.enumMetadata, 'CompanyType', res.result.type); //获取英文
        res.result.status = getEnumMetaValue(this.$store.getters.enumMetadata, 'CompanyStatus', res.result.status); //获取英文
        this.company = res.result;
        if (res) {
          this.$message.success({
            message: status=="Dropped"?"分销商解约成功":"分销商签约成功",
            showClose: true
          });
        }
      });
    },
    //控制显示/隐藏字段
    authLook(key) {
      this.hideInfo[key] = !this.hideInfo[key];
    },
    //更新分销商
    updateCompanie() {
      var formData = new FormData();
      formData.append("Company", JSON.stringify(this.company));
      if (JSON.stringify(this.photoFile) != "{}") {
        formData.append("PhotoFile", this.photoFile);
      }
      updateCompanie(this.$route.params.id, formData).then(res => {
        res.result.typeVal = res.result.type; //存储展示用
        res.result.statusVal = res.result.status; //存储展示用
        res.result.type = getEnumMetaValue(this.$store.getters.enumMetadata, 'CompanyType', res.result.type); //获取英文
        res.result.status = getEnumMetaValue(this.$store.getters.enumMetadata, 'CompanyStatus', res.result.status); //获取英文
        this.company = res.result;
        this.isEditBasic = false;
        if (res) {
          this.$message.success({
            message: `${this.company.name}信息更新成功`,
            showClose: true
          });
        }
      });
    },
    //根据分销商标识获取分销商电子档案信息
    getMaterials() {
      getMaterials(this.$route.params.id).then(res => {
      })
    },
    //根据分销商标识获取分销商股东信息
    getPartners() {
      getPartners(this.$route.params.id).then(res => {
        this.partners = res.result.items;
      });
    },
    //通过分销商标识获取详细信息
    getCompanieDetail() {
      getCompanieDetail(this.$route.params.id).then(res => {
        res.result.typeVal = res.result.type; //存储展示用
        res.result.statusVal = res.result.status; //存储展示用
        res.result.type = getEnumMetaValue(this.$store.getters.enumMetadata, 'CompanyType', res.result.type); //获取英文
        res.result.status = getEnumMetaValue(this.$store.getters.enumMetadata, 'CompanyStatus', res.result.status); //获取英文
        this.company = res.result;
        this.loading = false;
      });
    },
    //添加备注
    editRemarks() {
      this.isRemarkShow = true;
      this.remarkForm.more = deepCopy(this.company.more);
    },
    submitRemark() {
      this.isRemarkShow = false;
      this.company.more = this.remarkForm.more;
      this.isRemarkChange = true;
      this.updateCompanie();
    },
    //添加标签
    addTag() {
      this.isTagsShow = false;
    },
    delTag(index) {
      this.company.tags.splice(index, 1);
    },
    // 保存标签
    submitTag(isEnter) {
      if (this.headTag) {
        this.company.tags.push(this.headTag);
        this.headTag = "";
      }
      if (!isEnter) {
        this.isTagChange = true;
        this.isTagsShow = true;
        this.updateCompanie();
      }
    },
    // updateCompany() {
    //   if (this.isTagChange) {
    //     this.$message.success({
    //       message: "标签保存成功",
    //       showClose: true
    //     });
    //     this.isTagChange = false;
    //   } else if (this.isRemarkChange) {
    //     this.$message.success({
    //       message: "备注保存成功",
    //       showClose: true
    //     });
    //     this.isRemarkChange = false;
    //   } else {
    //     this.$message.success({
    //       message: "员工信息保存成功",
    //       showClose: true,
    //     });
    //   }
    // },
    // 保存
    submit() {
      this.$refs.companyForm.validate((valid) => {
        if (valid) {
          this.updateCompanie();
        } else {
          return false;
        }
      });
    },
    // 取消
    cancel() {
      this.isEditBasic = false;
    },
    //点击添加 股东
    addPartners() {
      if (!this.permissions['Company.ManageEventRecords']) {
        this.$message.warning({
          message: `您暂无管理分销商股东权限`,
          showClose: true,
        });
        return;
      }
      this.isAddPartnersShow = true;
      this.editPartnersIndex = null;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.editPartnersIndex == null) {
            //添加股东
            addPartners(this.$route.params.id, deepCopy(this.partnersForm)).then(res => {
              this.partners = res.result.items;
              if (res) {
                this.$message.success({
                  message: "股东添加成功",
                  showClose: true
                });
              }
            });
          } else {
            //编辑股东
            // this.partners.splice(this.editPartnersIndex, 1, deepCopy(this.partnersForm))
            var partnersForm = deepCopy(this.partnersForm);
            partnersForm.oldCardType = this.editPartnerData.cardType;
            partnersForm.oldCardNumber = this.editPartnerData.cardNumber;
            updatePartners(this.$route.params.id, partnersForm).then(res => {
              this.partners = res.result.items;
              if (res) {
                this.$message.success({
                  message: "股东信息修改成功",
                  showClose: true
                });
              }
            });
          }
          this.$refs[formName].resetFields();
          this.isAddPartnersShow = false;
        } else {
          
          return false;
        }
      });
    },
    handleClose(formName) {
      this.$refs[formName].resetFields();
      // this.partnersForm = this.$options.data().partnersForm;
      this.partnersForm = {
        name: '',
        cardType: '',
        cardNumber: '',
        phoneNumber: '',
        more: ''
      };
    },
    // 点击编辑 股东
    editPartners(index, rowData) {
      if (!this.permissions['Company.ManageEventRecords']) {
        this.$message.warning({
          message: `您暂无管理分销商股东权限`,
          showClose: true,
        });
        return;
      }
      this.editPartnerData = rowData; //存储编辑股东的信息
      this.isAddPartnersShow = true; //弹出
      this.editPartnersIndex = index; //下标
      this.partnersForm = deepCopy(rowData);
    },
    //删除股东
    deletePartners(index, rowData) {
      if (!this.permissions['Company.ManageEventRecords']) {
        this.$message.warning({
          message: `您暂无管理分销商股东权限`,
          showClose: true,
        });
        return;
      }
      this.$confirm('此操作将永久删除该股东, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        removePartners(this.$route.params.id, {
          cardType: rowData.cardType,
          cardNumber: rowData.cardNumber
        }).then(res => {
          this.partners = res.result.items;
          if (res) {
            this.$message({
              type: 'success',
              message: '删除成功!',
              showClose: true
            });
          }
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
          showClose: true
        });
      });
    },
    // 获取分销商基础字段
    getCompanySettings() {
      getCompanySettings().then(res => {
        res.result.forEach(item => {
          switch (item.name) {
            case 'Deer.Company.Collection.Nature':
              this.companyNatureOptions = item.value; //分销商公司性质
              break;
            case 'Deer.Company.Collection.RecruitWay':
              this.recruitWayOptions = item.value; //加盟渠道来源
              break;
            case 'Deer.Company.Collection.MaterialType': //资料附件类型
              break;
            case 'Deer.Company.Collection.EventType': //大事记类型
              break;
            case 'Deer.Company.Collection.DropWay': //加盟店退出方式
              break;
            case 'Deer.Company.Collection.MaterialType': //加盟店资料附件类型
              break;
            case 'Deer.Company.Collection.EventType': //加盟店大事记类型
              break;
          }
        });
      });
    },
    // 获取头像
    getFile(item) {
      this.photoFile = item.file;
      this.updateCompanie();
    },
    //图片大小
    beforeAvatarUpload(file) {
      const isPIC = file.type.indexOf("image") != -1;
      const isLt5M = file.size / 1024 / 1024 < 5;

      if (!isPIC) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt5M) {
        this.$message.error("上传图片大小不能超过 5MB!");
      }
      return isPIC && isLt5M;
    },
    // 头部初始化
    headerInit() {
      let headerEl = document.querySelectorAll(".header-top");
      if (!headerEl[1] || !headerEl[1].style) {
        return;
      }
      headerEl[1].style.width = headerEl[0].offsetWidth + "px";
      document.querySelector(".scroll-box").style.width =
        document.querySelector(".basic-info").offsetWidth + "px";
      this.isHeaderInit = true;
    },
    // 头部滚动样式
    scrollScreen() {
      let el = document.querySelector(".edit-employe");
      this.scroll = el.scrollTop;
      if (this.scroll > 0) {
        this.isHeaderVisible = true;
      } else {
        this.isHeaderVisible = false;
      }
      if (this.scroll >= 25) {
        this.isHeaderShadow = true;
      } else {
        this.isHeaderShadow = false;
      }
      if (this.scroll >= 339) {
        this.isScrollShow = true;
      } else {
        this.isScrollShow = false;
      }
    },
  }
};